import React from "react";
import { InputString } from "../../../common/controls";
import { useFormRecord } from "../../../../common/controls/forms/FormRecordContext";

/**
 * Link de Publicación de la edición (por ejemplo, el álbum en Spotify).
 *
 * Visible ÚNICAMENTE cuando el Tipo de Contenido del form es "Edición con
 * audios" (lee el valor vivo del campo hermano vía FormRecordContext) — en
 * ediciones con partituras no aplica y no se muestra. Cuando aplica es
 * OBLIGATORIO: el server lo exige al guardar (se declara en la DJCT y es la
 * URL de publicación web del registro DNDA); acá se marca requerido y el
 * error del server llega por helperText.
 */
export interface EditionPublicationLinkCustomFieldProps {
  value: any;
  onChange: (value: any) => void;
  error?: boolean;
  helperText?: string;
  label?: string;
  description?: string;
}

export const EditionPublicationLinkCustomField: React.FC<
  EditionPublicationLinkCustomFieldProps
> = ({ value, onChange, error, helperText, label, description }) => {
  const { values } = useFormRecord();

  if (values?.contentType !== "audios") {
    return null;
  }

  return (
    <InputString
      label={`${label} *`}
      placeholder="https://open.spotify.com/album/…"
      value={value ?? ""}
      error={error}
      helperText={helperText}
      description={description}
      onChange={(v: string) => onChange(v)}
    />
  );
};
